import { render } from "./horasNocturnasPlanta.vue?vue&type=template&id=2deb4d2e"
import script from "./horasNocturnasPlanta.vue?vue&type=script&lang=js"
export * from "./horasNocturnasPlanta.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__